module.exports = __webpack_public_path__ + "static/media/1.2e92e69b.jpg";